// Prevent custom elements from throwing if already defined
const originalDefine = window.customElements.define;
window.customElements.define = function safelyDefineCustomElement(
  name,
  constructor,
  options
) {
  if (window.customElements.get(name)) {
    return;
  }
  originalDefine.call(this, name, constructor, options);
};
